"use client";

import { useContentResource } from "@ctv/core";
import { FC_MWEB } from "@ctv/core/feature-control/constants";
import { logClientError } from "@ctv/core/utils/datadog/client";
import { ErrorPage, useFeatureControl, View } from "@ctv/shared-core/src";
import { Footer, Header } from "@ctv/shared/components/Layout";
import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { Dimensions } from "react-native";

type Props = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function Error({ error, reset }: Props) {
  const path = usePathname();
  const { CorporateGeneralErrorMessage: cr } = useContentResource();
  const { enabled: mwebEnabled } = useFeatureControl(FC_MWEB);
  const { width: screenWidth } = Dimensions.get("screen");
  const isMobile = screenWidth < 480 && mwebEnabled;

  useEffect(() => {
    const url =
      typeof window !== "undefined"
        ? window.location.pathname +
          window.location.search +
          window.location.hash
        : path;

    logClientError({
      error,
      context: { page: url, cause: error.cause },
    });
    return () => {};
  }, [error, path]);

  return (
    <View flex>
      {!isMobile && <Header />}
      <ErrorPage
        title={cr.fullPageTitle}
        caption={cr.fullPageDescription}
        button={{
          label: cr.fullPageCTA,
          onPress: reset,
        }}
      />
      {!isMobile && <Footer />}
    </View>
  );
}
